import React from 'react';
import PropTypes from 'prop-types';

export default function Loading({ title = '', subtitle = '' } = {}) {
  return (
    <div className="loading flex flex-1 flex-column margin-xl">
      <div className="loading__header">
        <h1>{title}</h1>
      </div>
      <div className="loading__image-container-search">
        <div className="spinner outer">
          <div className="spinner inner"></div>
        </div>
        <p className="text-lighter">{subtitle}</p>
      </div>
    </div>
  );
}

Loading.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
